import {Injectable} from '@angular/core';
import {ValidatorService} from '../../services/validator.service';
import {Observable} from 'rxjs/index';
import {TrustAnchorVO} from '../../generate/TopLevelDomainVO';
import {ErrorVO} from '../../generate/ErrorVO';
import {checkIfGivenStringIsNumber, checkIfValueIsHex} from '../../util/CommonFunctions';

@Injectable()
export class TrustAnchorsValidatorsService {

  constructor(private validatorService: ValidatorService) {
  }

  serverValidation(trustAnchors : Array<TrustAnchorVO>): Observable<ErrorVO> {
    return this.validatorService.validateTrustAnchors(trustAnchors);
  }


  validateTrustAnchor(trustAnchor: TrustAnchorVO, trustAnchors: Array<TrustAnchorVO>, reqLength: number) : Map<string, Array<string>>{

    const errors = new Map<string, Array<string>>();
    const keyTag: number = trustAnchor.keyTag;

    let keyTagErrors: Array<string> = [];
    let keyDigestErrors: Array<string> = [];
    if (!checkIfGivenStringIsNumber(keyTag + "")) {
      keyTagErrors.push("Key tag value must be a number between 0 - 65535 (inclusive).");
    }
    if (keyTag < 0 || keyTag > 65535) {
      keyTagErrors.push("Key tag value must be between 0 - 65535 (inclusive).");
    }

    if (keyTagErrors.length > 0) {
      errors.set("keyTag", keyTagErrors);
    }


    // Key Digest
    const keyDigest: string = trustAnchor.digest;
    if (keyDigest.length != reqLength) {
      keyDigestErrors.push("The key digest length for " + trustAnchor.digestType + " should be " + reqLength + '.');
    }

    if (keyDigest.length > 0 && !checkIfValueIsHex(keyDigest)) {
      keyDigestErrors.push("The key digest must be in HEX format.");
    }


    let keyDigests: string[] = [];

    if (trustAnchors !== null) {
      trustAnchors.forEach(ta => keyDigests.push(ta.digest));
    }

    if (keyDigestErrors.length > 0) {
      errors.set("keyDigest", keyDigestErrors);
    }
    return errors;


  }
}
